import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(value) {
  return new Intl.NumberFormat('tr-TR', {
    style: 'currency',
    currency: 'TRY',
    minimumFractionDigits: 2,
  }).format(value);
}

export function formatNumber(value, decimals = 2) {
  return new Intl.NumberFormat('tr-TR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
}

export function formatDate(dateString) {
  return new Date(dateString).toLocaleDateString('tr-TR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

export function formatDateTime(dateString) {
  return new Date(dateString).toLocaleString('tr-TR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function getCategoryLabel(category) {
  const labels = {
    et: 'Et',
    sebze: 'Sebze',
    baharat: 'Baharat',
    icecek: 'İçecek',
    alkollu_icecek: 'Alkollü İçecek',
    temizlik: 'Temizlik',
    paketleme: 'Paketleme',
    gida: 'Gıda',
    ana_yemek: 'Ana Yemek',
    baslangic: 'Başlangıç',
    tatli: 'Tatlı',
    icecekler: 'İçecekler',
    karkas: 'Karkas/Gövde',
    islenenmis: 'İşlenmiş Et',
    ambalaj: 'Ambalaj',
    diger: 'Diğer',
  };
  return labels[category] || category;
}

export function getUnitLabel(unit) {
  const labels = {
    kg: 'Kilogram',
    lt: 'Litre',
    adet: 'Adet',
    gr: 'Gram',
    ml: 'Mililitre',
  };
  return labels[unit] || unit;
}

export function getStockStatus(total, min) {
  if (total === 0) return 'critical';
  if (total <= min) return 'low';
  return 'ok';
}

export function getStockStatusLabel(status) {
  const labels = {
    critical: 'Kritik',
    low: 'Düşük',
    ok: 'Normal',
  };
  return labels[status] || status;
}
